import { useMemo } from 'react';

/**
 * Calculate timeframe boundaries for filtering todos
 * @returns {Object} - Object containing all timeframe boundaries
 */
export const useTimeframes = () => {
  return useMemo(() => {
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    
    const endOfWeek = new Date(startOfToday);
    endOfWeek.setDate(endOfWeek.getDate() + (7 - endOfWeek.getDay()));
    
    const endOfNextWeek = new Date(endOfWeek);
    endOfNextWeek.setDate(endOfNextWeek.getDate() + 7);
    
    const endOfNextMonth = new Date(startOfToday);
    endOfNextMonth.setMonth(endOfNextMonth.getMonth() + 1);

    return {
      now,
      startOfToday,
      endOfWeek,
      endOfNextWeek,
      endOfNextMonth,
    };
  }, []);
};

/**
 * Get timeframe boundaries (non-hook version for outside React components)
 */
export const getTimeframes = () => {
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  
  const endOfWeek = new Date(startOfToday);
  endOfWeek.setDate(endOfWeek.getDate() + (7 - endOfWeek.getDay()));
  
  const endOfNextWeek = new Date(endOfWeek);
  endOfNextWeek.setDate(endOfNextWeek.getDate() + 7);
  
  const endOfNextMonth = new Date(startOfToday);
  endOfNextMonth.setMonth(endOfNextMonth.getMonth() + 1);

  return {
    now,
    startOfToday,
    endOfWeek,
    endOfNextWeek,
    endOfNextMonth,
  };
};

export default useTimeframes;
